import type { Dayjs } from 'dayjs';

export const Operators = {
  Contain: 'Contain',
  Equal: 'Equal',
  NotEqual: 'Not Equal',
} as const;

export interface DisabledIf {
  Operator: OperatorsType;
  Question: string;
  Value: string;
}

export interface EnableWhen {
  Answer: (Dayjs | number | string)[];
  Operator: OperatorsType;
  Question: string;
}

export interface TemplateFormItem {
  AnswerOption?: string[];
  Description?: string;
  DisabledIf?: DisabledIf[];
  EnableBehavior?: null | string;
  EnableWhen?: EnableWhen | null;
  Header?: string;
  Item?: TemplateFormItem[];
  LastUpdated?: string;
  LinkId: string;
  PlaceHolder?: string;
  Required: boolean | null;
  Scores?: Score[];
  ShowQuestionNo?: boolean;
  Text: string;
  Type: string;
  Validations?: Validation[];
  Value?: string;
  Version?: string;
}

export interface Validation {
  Conditions: string[];
  Field?: string;
  Limits?: Limit[];
  Message: string;
  Type?: string;
}

interface Limit {
  Key: string;
  Value: string;
}

type OperatorsType = (typeof Operators)[keyof typeof Operators];

interface Score {
  Option: string;
  Score: number;
}
